import { render, staticRenderFns } from "./FacebookBlue.vue?vue&type=template&id=48cfe01a&scoped=true&"
import script from "./FacebookBlue.vue?vue&type=script&lang=js&"
export * from "./FacebookBlue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cfe01a",
  null
  
)

export default component.exports